import { useState, useEffect, useRef } from "react";
import { FaGithub, FaLinkedin  } from "react-icons/fa";

function Footer() {
  const [emailTooltip, setEmailTooltip] = useState(false);
  // const [phoneTooltip, setPhoneTooltip] = useState(false);
  
  // Refs for the email and phone icons to detect clicks outside them
  const emailRef = useRef(null);
  // const phoneRef = useRef(null);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (emailRef.current && !emailRef.current.contains(event.target)) {
        setEmailTooltip(false); // Close email tooltip if clicked outside
      }
      // if (phoneRef.current && !phoneRef.current.contains(event.target)) {
      //   setPhoneTooltip(false); // Close phone tooltip if clicked outside
      // }
    };

    // Add event listener to the document
    document.addEventListener("mousedown", handleClickOutside);

    // Cleanup the event listener
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  return (
    <footer
      id="footer"
      name="footer"
      className="bg-footer text-white py-8">
      <div className="site-container footer-container">
        <div className="footer-heading">
          <h2>Connect</h2>
          <p>Find me and my work across the web.</p>
        </div>

        <div className="footer-links">

          <div
            ref={emailRef}
            className="footer-link-item relative"
          >
            <a
              href="mailto:contact@tuhindutta.com"
              title="contact@tuhindutta.com"
              className="text-blue-400 hover:text-blue-600 transition duration-300 hover:opacity-80 hover:scale-110"
              target="_blank"
              rel="noopener noreferrer"
              onClick={() => setEmailTooltip(!emailTooltip)}
            >
              <span className="footer-icon">✉</span>
            </a>

            {emailTooltip && (
              <div className="absolute bottom-12 left-1/2 transform -translate-x-1/2 bg-black text-white text-xs p-2 rounded-md shadow-lg">
                contact@tuhindutta.com
              </div>
            )}
            <span>Email</span>
          </div>

          {/* Phone 1*/}
          {/* <div
            ref={phoneRef} // Attach the ref to phone container
            className="flex flex-col items-center w-20 relative"
          >
            <a
              href="tel:+911234567890"
              title="+91 12345 67890"
              className="text-blue-400 hover:text-blue-600 transition duration-300"
              target="_blank"
              rel="noopener noreferrer"
              onClick={() => setPhoneTooltip(!phoneTooltip)} // Handle tap
            >
              <span className="text-2xl sm:text-3xl">📞</span>
            </a>
            {phoneTooltip && (
              <div className="absolute bottom-12 left-1/2 transform -translate-x-1/2 bg-black text-white text-xs p-2 rounded-md shadow-lg">
                +91 12345 67890
              </div>
            )}
            <span className="text-xs sm:text-sm text-blue-400 mt-2">
              Phone 1 / Whatsapp
            </span>
          </div> */}

          {/* LinkedIn */}
          <div className="footer-link-item">
            <a
              href="https://www.linkedin.com/in/t-k-dutta"
              className="text-blue-400 hover:text-blue-600 transition duration-300 hover:scale-110"
              target="_blank"
              rel="noopener noreferrer"
            >
              <FaLinkedin className="footer-icon" />
            </a>
            <span>LinkedIn</span>
          </div>

          {/* GitHub */}
          <div className="footer-link-item">
            <a
              href="https://github.com/tuhindutta"
              className="text-blue-400 hover:text-blue-600 transition duration-300 hover:scale-110"
              target="_blank"
              rel="noopener noreferrer"
            >
              {/* <span className="text-2xl sm:text-3xl">💻</span> */}
              <FaGithub className="footer-icon" />
            </a>
            <span>GitHub</span>
          </div>

          {/* Blog */}
          <div className="footer-link-item">
            <a
              href="https://statisticallyspeaking.tuhindutta.com/"
              className="text-blue-400 hover:text-blue-600 transition duration-300 hover:opacity-80 hover:scale-110"
              target="_blank"
              rel="noopener noreferrer"
            >
              <img
                src="https://cdn.hashnode.com/res/hashnode/image/upload/v1746943159393/a43556da-e26d-48e3-bf35-d91cc74b0a1e.png"
                alt="StatisticallySpeaking"
                className="footer-image-icon"
              />
              {/* <span className="text-2xl sm:text-3xl">📝</span> */}
            </a>
            <span>Statistically Speaking</span>
          </div>

          {/* Blog */}
          <div className="footer-link-item">
            <a
              href="https://techtrail.tuhindutta.com/"
              className="text-blue-400 hover:text-blue-600 transition duration-300 hover:opacity-80 hover:scale-110"
              target="_blank"
              rel="noopener noreferrer"
            >
              <img
                src="https://cdn.hashnode.com/res/hashnode/image/upload/v1753638509901/b4cd13d7-1900-403d-8229-375539a4170c.png"
                alt="TechTrail"
                className="footer-image-icon"
              />
              {/* <span className="text-2xl sm:text-3xl">📝</span> */}
            </a>
            <span>Tech Trail</span>
          </div>

          {/* Blog */}
          <div className="footer-link-item">
            <a
              href="https://criticalmind.tech.blog/"
              className="text-blue-400 hover:text-blue-600 transition duration-300 hover:opacity-80 hover:scale-110"
              target="_blank"
              rel="noopener noreferrer"
            >
              <div className="footer-icon-wrap">
                <img
                  src="https://criticalmind.tech.blog/wp-content/uploads/2021/10/cropped-logo-2.png"
                  alt="Kaggle"
                  className="footer-image-icon"
                />
              </div>
              {/* <span className="text-2xl sm:text-3xl">📝</span> */}
            </a>
            <span>Critical Mind</span>
          </div>

          {/* Kaggle */}
          <div className="footer-link-item">
            <a
              href="https://www.kaggle.com/tuhinkumardutta"
              className="text-blue-400 hover:text-blue-600 transition duration-300 hover:opacity-80 hover:scale-110"
              target="_blank"
              rel="noopener noreferrer"
            >
              <div className="footer-icon-wrap">
                <img
                  src="https://www.vectorlogo.zone/logos/kaggle/kaggle-icon.svg"
                  alt="Kaggle"
                  className="footer-image-icon"
                />
              </div>
            </a>
            <span>Kaggle</span>
          </div>

        </div>


        <div className="footer-meta">
          <p>&copy; {new Date().getFullYear()} Tuhin. All Rights Reserved.</p>
          <p>Last updated: Oct 2026</p>
        </div>
      </div>
    </footer>
  );
}

export default Footer;